if (!customElements.get('custom-klaviyo-form')) {

    const KLAVIYO_PROFILE_FIELDS = new Set(['email', 'first_name', 'last_name', 'phone_number', 'image', 'title', 'organization', 'location']);

    class CustomKlaviyoForm extends HTMLElement {
        constructor() {
            super();
            this.companyID = this.dataset?.companyId;
            this.klaviyoForm = this.querySelector('form[id^="sign-up-form"]');
            this.klaviyoFormID = this.querySelector('[name="g"]')?.value;
            this.successWrapper = this?.querySelector('.succes-wrapper');
            this.defaultTitle = this?.querySelector('.klaviyo-form-title-wrapper');
            this.submitToBoth = this.dataset?.submitToBoth === 'true';
            this.shopifyForm = this.querySelector('form.contact-form-shopify-mirror');

            this.klaviyoForm?.addEventListener('submit', (e) => this.onSubmitHandler(e));

            if (this.submitToBoth && this.klaviyoForm && this.shopifyForm) {
                this.setupMirroring();
            }

            this.addEventListener('click', (e) => {
                if (e.target.closest('.field-wrapper') || e.target.closest('.select-dropwdown-wrapper')) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'klaviyo_form_started',
                        'eventLabel': `${this.klaviyoFormID}`
                    });
                }
            }, { once: true });
        }

        onSubmitHandler(e) {
            e.preventDefault();
            const gtmId = this.dataset.gtmUniqueId;
            if (gtmId) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ event: 'form_submit_inquery', form_id: gtmId });
            }
            const formData = Object.fromEntries(new FormData(e.target));
            this.postRequest(formData);
            if (this.submitToBoth && this.shopifyForm) {
                this.mirrorToShopifyForm();
                this.submitShopifyForm();
            }
        }

        setupMirroring() {
            const events = ['input', 'change'];
            for (const eventType of events) {
                this.klaviyoForm.addEventListener(eventType, () => this.mirrorToShopifyForm());
            }
        }

        mirrorToShopifyForm() {
            if (!this.shopifyForm) return;
            const formData = Object.fromEntries(new FormData(this.klaviyoForm));
            const mirrorInputs = this.shopifyForm.querySelectorAll('[data-klaviyo-name]');
            for (const input of mirrorInputs) {
                const klaviyoName = input.getAttribute('data-klaviyo-name');
                if (klaviyoName === 'name') {
                    const firstName = formData.first_name?.trim() ?? '';
                    const lastName = formData.last_name?.trim() ?? '';
                    input.value = [firstName, lastName].filter(Boolean).join(' ') || (formData.name?.trim() ?? '');
                } else {
                    input.value = formData[klaviyoName] ?? '';
                }
            }
        }

        submitShopifyForm() {
            if (!this.shopifyForm) return;
            const doSubmit = () => {
                this.mirrorToShopifyForm();
                this.shopifyForm.submit();
            };
            if (window.Shopify?.captcha?.protect) {
                window.Shopify.captcha.protect(this.shopifyForm, doSubmit);
            } else {
                doSubmit();
            }
        }

        async postRequest(formData) {
            const body = this.buildRequestBody(formData);
            const url = `https://a.klaviyo.com/client/subscriptions?company_id=${this.companyID}`;
            const options = {
                method: 'POST',
                keepalive: true,
                headers: { revision: '2025-01-15', 'content-type': 'application/vnd.api+json' },
                body: JSON.stringify(body)
            };

            try {
                const response = await fetch(url, options);
                if (!response.ok) throw new Error('Network response was not ok');
                if(!this.submitToBoth){
                    this.showSuccessMessage();
                }
            } catch (error) {
            }
        }

        buildRequestBody(formData) {
            const { g, name, ...fields } = formData;
            const profileAttributes = {};
            const properties = {};

            for (const [key, value] of Object.entries(fields)) {
                if (!value) continue;

                if (KLAVIYO_PROFILE_FIELDS.has(key)) {
                    profileAttributes[key] = value.trim();
                } else {
                    properties[key] = value;
                }
            }

            if (name && !profileAttributes.first_name) {
                profileAttributes.first_name = name.trim();
            }
            const payload = {
                data: {
                    type: 'subscription',
                    attributes: {
                        profile: {
                            data: {
                                type: 'profile',
                                attributes: {
                                    subscriptions: {
                                        email: {
                                            marketing: {
                                                consent: 'SUBSCRIBED',
                                            },
                                        },
                                    },
                                    ...profileAttributes,
                                    ...(Object.keys(properties).length && { properties }),
                                },
                            },
                        },
                    },
                },
            }
            if(g){
                payload.data.relationships = {
                    list: {
                        data: {
                            type: 'list',
                            id: g,
                        },
                    },
                }
            }

            return payload
        }

        showSuccessMessage() {
            const hideMode = this.dataset.successHide ?? 'button';

            if (hideMode === 'form') {
                this.defaultTitle?.classList.add('hidden');
                this.klaviyoForm?.classList.add('hidden');
            } else {
                this.klaviyoForm?.querySelector('[type="submit"]')?.closest('.klaviyo-submit')?.classList.add('hidden');
            }

            this.successWrapper?.classList.remove('hidden');
        }
    }

    customElements.define('custom-klaviyo-form', CustomKlaviyoForm);
}
